// extracted by mini-css-extract-plugin
export default {"button":"BlackButton_button__PTSJY","small":"BlackButton_small__nNGAU","medium":"BlackButton_medium__XhXoP","large":"BlackButton_large__iD1c7"};